import { useEffect, useMemo, useState } from "react";

export default function ProductGallery({ images = [], productTitle }) {
  const orderedImages = useMemo(
    () =>
      [...images].sort(
        (left, right) =>
          Number(right.isPrimary) - Number(left.isPrimary) ||
          Number(left.position) - Number(right.position)
      ),
    [images]
  );
  const [activeImageId, setActiveImageId] = useState(
    orderedImages[0]?.id || null
  );

  useEffect(() => {
    setActiveImageId(orderedImages[0]?.id || null);
  }, [orderedImages]);

  const activeIndex = Math.max(
    orderedImages.findIndex((image) => image.id === activeImageId),
    0
  );
  const activeImage = orderedImages[activeIndex];

  const move = (direction) => {
    if (orderedImages.length < 2) return;
    const nextIndex =
      (activeIndex + direction + orderedImages.length) % orderedImages.length;
    setActiveImageId(orderedImages[nextIndex].id);
  };

  return (
    <section className="product-gallery" aria-label="Imagens do produto">
      <div className="product-gallery__main">
        {activeImage ? (
          <img
            src={activeImage.url}
            alt={activeImage.altText || productTitle}
            decoding="async"
          />
        ) : (
          <div className="product-gallery__empty">
            <svg viewBox="0 0 24 24" aria-hidden>
              <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-13Zm1.5 0v9.65l3.1-3.1a1.5 1.5 0 0 1 2.12 0l1.28 1.28 2.78-2.78a1.5 1.5 0 0 1 2.12 0l1.6 1.6V5.5h-13Zm13 8.77-2.66-2.66-4.9 4.9a.75.75 0 0 1-1.06 0l-.22-.22-2.21 2.21H18.5v-4.23Z" />
            </svg>
            <span>Produto sem imagem</span>
          </div>
        )}

        {orderedImages.length > 1 && (
          <>
            <button
              type="button"
              className="gallery-arrow gallery-arrow--previous"
              aria-label="Imagem anterior"
              onClick={() => move(-1)}
            >
              <svg viewBox="0 0 24 24" aria-hidden>
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>
            <button
              type="button"
              className="gallery-arrow gallery-arrow--next"
              aria-label="Próxima imagem"
              onClick={() => move(1)}
            >
              <svg viewBox="0 0 24 24" aria-hidden>
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
            <span className="product-gallery__counter">
              {activeIndex + 1} / {orderedImages.length}
            </span>
          </>
        )}
      </div>

      {orderedImages.length > 1 && (
        <div className="product-gallery__thumbnails">
          {orderedImages.map((image, index) => (
            <button
              type="button"
              className={
                image.id === activeImage?.id
                  ? "gallery-thumbnail gallery-thumbnail--active"
                  : "gallery-thumbnail"
              }
              aria-label={`Ver imagem ${index + 1}`}
              aria-current={image.id === activeImage?.id}
              onClick={() => setActiveImageId(image.id)}
              key={image.id}
            >
              <img
                src={image.url}
                alt=""
                loading="lazy"
                decoding="async"
              />
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
